export default __webpack_public_path__ + "static/media/logo-trade-republic-white.c5fd6c79.svg";